import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

class ReCaptchaRecord extends BaseMessageRecord({
  type: "recaptcha",

  /** @memberof ReCaptchaRecord# */
  body: ""
}) {
  static getInvalidFields = () => Immutable.List()
}

export default ReCaptchaRecord;
